export enum AclEnum {
    ADMIN = 'ADMIN',
    SELLER_PLATFORM = 'SELLER_PLATFORM',
    PRODUCER = 'PRODUCER',
    AFFILIATE = 'AFFILIATE',
    STUDENT = 'STUDENT',
    ADMIN_MEMBER_AREA = 'ADMIN_MEMBER_AREA'
}
